<template>
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color':currentIntegration.color.main}">
        <div slot="title">
            <h2>Stripe</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" />

            <!-- Lower area -->
            <div class="px-5 pt-4 pb-4">
                <div v-if="isLoadingIntegrationDetails" class="text-center w-100 p-3">
                    <loader />
                </div>

                <div v-else class="pb-3">
                    <div class="mb-3 border-color-6 p-2 radius-normal bg-red-pale" v-if="showTestKeysWarning">
                        Warning: You are using a Test Stripe Account, make sure to use Live Keys when you are ready to sell your products via Widget
                    </div>

                    <label for="stripeSecretKey">Secret Key</label>
                    <input name="stripeSecretKey" type="text" v-model="integrationDetails.stripeSecretKey" class="w-100">

                    <label for="stripePublicKey">Public Key</label>
                    <input name="stripePublicKey" type="text" v-model="integrationDetails.stripePublicKey" class="w-100">
                </div>

                <bottom-area
                    :isIntegrated="currentIntegration.integrationStatus == 1"
                    :showSaveBtn="true"
                    @disableIntegration="disableIntegration()"
                    @saveIntegration="saveIntegration"
                    @close="closeModal()"
                />
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Modal from '@/tools/modal/Modal'
    import loader from '@/tools/loaders/loader1'
    import topArea from './popupParts/topArea'
    import bottomArea from './popupParts/bottomArea'

    export default {
        created() {
            this.isLoadingIntegrationDetails = true;
            this.downloadPaymentIntegrationDetails(101).then(response => {
                this.isLoadingIntegrationDetails = false;
                this.integrationDetails = response.data;
            })
        },
        data() {
            return {
                isLoadingIntegrationDetails: false,
                integrationDetails: null
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedIntegration'
            ]),
            currentIntegration() {
                return this.getSelectedIntegration;
            },
            showTestKeysWarning() {
                if (this.integrationDetails.stripeSecretKey == null || this.integrationDetails.stripePublicKey == null) {
                    return false;
                } else if (this.integrationDetails.stripeSecretKey.includes("test") || this.integrationDetails.stripePublicKey.includes("test")) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            ...mapActions([
                'downloadPaymentIntegrationDetails',
                'saveStripeIntegration',
                'closeModal',
                'downloadSupplierIntegrations'
            ]),
            disableIntegration() {
                this.saveStripeIntegration({
                    secretKey: null,
                    publicKey: null
                }).then(response => {
                    this.downloadSupplierIntegrations();
                    this.closeModal();
                })
            },
            saveIntegration() {
                this.saveStripeIntegration({
                    secretKey: this.integrationDetails.stripeSecretKey,
                    publicKey: this.integrationDetails.stripePublicKey
                }).then(response => {
                    this.downloadSupplierIntegrations();
                    this.closeModal();
                })
            }
        },
        components: {
            topArea,
            bottomArea,
            Modal,
            loader
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// stripeIntegrate.vue?40ba3576